export const language: any = {
    LabelFavorites: "Favoris",
    LabelYouDontHaveRecipeAddYourFavoriteRecipe: `Vous n'avez pas encore de plats favoris.<br/>Ajoutez vos plats préférés !`,
    LabelDoYouWantUnSave: `Voulez-vous retirer cette recette de vos favoris ?`,
    save: "Enregistrer",
    unsave: "Enregistrer",
    OkFavorite: "Oui",
    CloseFavorite: "Non",
};